import { z } from 'zod';
/**
 * Sincronización automática desde el sistema anterior (una sola vía: legacy → Facture) y corte a producción.
 * Mientras el programador esté activo, cada cierto tiempo se trae lo nuevo o modificado (modo incremental) de
 * todas las compañías ya migradas. El corte desactiva la sincronización y la bloquea: después de pasar a
 * producción una sincronización pisaría lo que se edite en Facture.
 */
export const LEGACY_SYNC_INTERVALS = [5, 10, 15, 30, 60, 120, 360, 720, 1440];
export const legacySyncScheduleInput = z.object({
    enabled: z.boolean(),
    intervalMinutes: z
        .number()
        .int()
        .refine((n) => LEGACY_SYNC_INTERVALS.includes(n), {
        message: 'Intervalo no permitido',
    }),
});
/** El corte exige escribir la palabra para evitar un clic accidental. */
export const legacyCutoverInput = z.object({ confirm: z.literal('FINALIZAR') });
//# sourceMappingURL=legacy-sync.js.map